import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

const HeaderCard = () => {
  return (
    <div className={classNames('flex-row-wrap', 'flex-between-start', styles.headerCard)}>
      <div className={styles.headerCardItem}>
        <div className={styles.headerCardItemTit}>精准曝光</div>
        <div className={styles.headerCardItemContent}>
          基于CBNData全域触点，精准辐射数百万行业用户。通过产品介绍、功能描述及合作案例，全方位展示产品信息，帮助产品提升买方认知与品牌影响力。
        </div>
      </div>
      <div className={styles.headerCardItem}>
        <div className={styles.headerCardItemTit}>潜客转化</div>
        <div className={styles.headerCardItemContent}>
          通过产品询价，CBNData定期同步高意愿客户信息，助力产品完成潜客转化。
        </div>
      </div>
    </div>
  );
};
export default HeaderCard;
